import { Button } from "../Button";
import { HourTypeDropDown } from "./HourTypeDropDown";

export const HourSlice = (props) => {

    const {
        index,
        nameStartTime,
        nameEndTime,
        nameHourType,
        listHourTypes,
        valueStartTime,
        valueEndTime,
        valueHourType,
        setStartTime,
        setEndTime,
        setHourType,
        placeholder,
        className,
        classNameWrapper,
        onRemove,
        classNameHourType,
        disabled,
        desktopLayout,
    } = props;

    const isDesktopSingleLine = desktopLayout === "single";
    return (
        <div className={classNameWrapper || "mb-3"}>
            <div
                className={[
                    "rounded-lg border border-gray-200 bg-white p-3",
                    disabled === true ? "opacity-70" : "",
                ].join(" ")}
            >
                <div
                    className={[
                        "grid grid-cols-1 gap-3",
                        isDesktopSingleLine
                            ? "xl:grid-cols-[minmax(0,1fr)_9rem_auto_9rem_auto] xl:items-end"
                            : "",
                    ].join(" ")}
                >
                    <div className="min-w-0">
                        {nameHourType ? (
                            <div className={["text-xs font-medium text-gray-600", isDesktopSingleLine ? "xl:sr-only" : ""].join(" ")}>
                                {nameHourType}
                            </div>
                        ) : (
                            <div className="sr-only">Type d'heure</div>
                        )}
                        <div className={["mt-1", isDesktopSingleLine ? "xl:mt-0" : ""].join(" ")}>
                            <HourTypeDropDown
                                index={index}
                                nameHourType={nameHourType}
                                listHourTypes={listHourTypes}
                                valueHourType={valueHourType}
                                setHourType={setHourType}
                                className={
                                    classNameHourType ||
                                    "w-full appearance-none bg-gray-50 border border-gray-200 text-gray-800 py-2 px-3 rounded-md leading-tight focus:outline-hidden focus:bg-white focus:border-gray-400"
                                }
                                disabled={disabled === true}
                            />
                        </div>
                        {disabled === true ? (
                            <div className={["mt-2", isDesktopSingleLine ? "xl:mt-1" : ""].join(" ")}>
                                <span className="inline-flex items-center rounded-full bg-gray-100 px-2 py-1 text-xs font-medium text-gray-700">
                                    Verrouillé
                                </span>
                            </div>
                        ) : null}
                    </div>

                    <div
                        className={[
                            isDesktopSingleLine ? "contents" : "flex items-end gap-2 sm:gap-3",
                        ].join(" ")}
                    >
                        <div className={["min-w-0", isDesktopSingleLine ? "" : "flex-1"].join(" ")}>
                            <label
                                htmlFor={"start_time_" + index}
                                className={[
                                    "block text-xs font-medium text-gray-600",
                                    isDesktopSingleLine ? "xl:sr-only" : "",
                                ].join(" ")}
                            >
                                {nameStartTime}
                            </label>
                            <input
                                id={"start_time_" + index}
                                className={
                                    className ||
                                    "mt-1 block w-full rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-gray-800 leading-tight focus:outline-hidden focus:bg-white focus:border-gray-400"
                                }
                                name={nameStartTime}
                                value={String(valueStartTime ?? "").substring(0, 5)}
                                onChange={(e) => {
                                    if (disabled === true) return;
                                    setStartTime(e.target.value, index);
                                }}
                                type="time"
                                placeholder={placeholder || ""}
                                disabled={disabled === true}
                            />
                        </div>

                        <div
                            className={[
                                "shrink-0 items-center justify-center text-gray-400",
                                isDesktopSingleLine ? "hidden xl:flex" : "flex pb-2",
                            ].join(" ")}
                        >
                            <span aria-hidden="true">→</span>
                        </div>

                        <div className={["min-w-0", isDesktopSingleLine ? "" : "flex-1"].join(" ")}>
                            <label
                                htmlFor={"end_time_" + index}
                                className={[
                                    "block text-xs font-medium text-gray-600",
                                    isDesktopSingleLine ? "xl:sr-only" : "",
                                ].join(" ")}
                            >
                                {nameEndTime}
                            </label>
                            <input
                                id={"end_time_" + index}
                                className={
                                    className ||
                                    "mt-1 block w-full rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-gray-800 leading-tight focus:outline-hidden focus:bg-white focus:border-gray-400"
                                }
                                name={nameEndTime}
                                value={String(valueEndTime ?? "").substring(0, 5)}
                                onChange={(e) => {
                                    if (disabled === true) return;
                                    setEndTime(e.target.value, index);
                                }}
                                type="time"
                                placeholder={placeholder || ""}
                                disabled={disabled === true}
                            />
                        </div>

                        <div className="flex shrink-0 items-center justify-end">
                            {onRemove && disabled !== true ? (
                                <Button
                                    action={() => {
                                        onRemove(index);
                                    }}
                                    type="custom"
                                    title="Supprimer"
                                    customCN="inline-flex items-center justify-center rounded-md border border-transparent p-2 text-red-700 hover:bg-red-50 hover:text-red-800 focus:outline-hidden focus:shadow-outline"
                                    name={
                                        <>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="h-5 w-5"
                                                aria-hidden="true"
                                            >
                                                <path d="M3 6h18" />
                                                <path d="M8 6V4h8v2" />
                                                <path d="M19 6l-1 14H6L5 6" />
                                                <path d="M10 11v6" />
                                                <path d="M14 11v6" />
                                            </svg>
                                            <span className="sr-only">Supprimer</span>
                                        </>
                                    }
                                />
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

